import { createAccessControlProvider } from '@frontend/components/agromarket/core/access-control'
import { HARVEST_SALE_LOTS_ACCESS_CONTROL_LIST } from './constants'
import type { THarvestSaleLotsAccessControlContext, THarvestSaleLotsAccessControlList } from './types'

export const { AccessControlProvider: HarvestSaleLotsAccessControlProvider, useAccessControl: useHarvestSaleLotsAccessControl } =
  createAccessControlProvider<THarvestSaleLotsAccessControlList, THarvestSaleLotsAccessControlContext>(
    HARVEST_SALE_LOTS_ACCESS_CONTROL_LIST,
  )
